import api from './api';

const vaultReconcileService = {
    get: (vaultId) =>
        api.get(`/vault-reconcile?vaultId=${vaultId}`),
    recalculate: (vaultId) =>
        api.post('/vault-reconcile', { vaultId }),
};

export default vaultReconcileService;
